import { render, staticRenderFns } from "./investment.component.vue?vue&type=template&id=73219084&scoped=true"
import script from "./investment.component.vue?vue&type=script&lang=js"
export * from "./investment.component.vue?vue&type=script&lang=js"
import style0 from "./investment.component.vue?vue&type=style&index=0&id=73219084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73219084",
  null
  
)

export default component.exports